module.exports = __webpack_public_path__ + "static/media/compare-vehicle-screenshot.e0b09197.png";